import styled from "styled-components";

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`